import transitions from "@material-ui/core/styles/transitions";
import { createTheme  } from "@material-ui/core/styles";

export const theme = createTheme ({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#dc004e",
        },
    },
    typography: {
        fontFamily: "Roboto, Arial, sans-serif",
    },
});
